import { render } from "./DeleteItem.vue?vue&type=template&id=0a75741c"
import script from "./DeleteItem.vue?vue&type=script&lang=js"
export * from "./DeleteItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Thanusan/My/TRAINN-Assignment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__